import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constant';
import { PiopiyService } from '../voiceService/piopiy.service';

const BASE_URL = environment.apiBaseUrl;

@Injectable({
  providedIn: 'root',
})
export class DevoteeService {
  constructor(private http: HttpClient, private piopiy: PiopiyService) { }
  private dataSubject = new BehaviorSubject<any[]>([]);
  data$: Observable<any[]> = this.dataSubject.asObservable();

  addNewDevotee(
    devoteeDetails: any,
    addressDetails: any,
    otherDetails: any,
    nibedonDetails: any
  ) {
  let userId = localStorage.getItem('currentUserId')

    const { firstName,middleName, lastName, familyCode, phoneNumber, alternatePhoneNumber, gender, age } =
      devoteeDetails;
    const { address, pincode, district, state, po } = addressDetails;
    const { nivedanCategory, initiated, swastayini, ritwikName, martialStatus } = otherDetails;
    const { nibedon, remarks, isUrgent, call_id } = nibedonDetails;

    const url = `${BASE_URL}${API_ENDPOINTS.NIVEDAN}`;
    return this.http.post<any>(
      url,
      {
        devoteeDetails: {
          married: martialStatus,
          ritwikName: ritwikName,
          swastayani: swastayini,
          initiated: initiated,
          state: state,
          dist: district,
          address: address,
          pin: pincode,
          gender: gender,
          age: age,
          familyCode: familyCode,
          lastName: lastName,
          firstName: firstName,
          middleName: middleName,
          phoneNumber: phoneNumber,
          alternateMobileNumber: alternatePhoneNumber,
          postOffice: po
        },
        nivedanDetails: {
          createdByRole: 'AGENT',
          createdBy: userId,
          recordingPath: null,
          recordingStatus: null,
          remark: remarks,
          nivedanDetails: nibedon,
          isUrgent:isUrgent,
          categoryCode: nivedanCategory,
          status: 'PENDING ON ADMIN',
          agentCode: 'string',
          call_id: this.piopiy.getCallId()
        },
      },
    );
  }

  fetchDevoteeDetails(params?: any): Observable<any> {
  const url = `${BASE_URL}${API_ENDPOINTS.NIVEDAN}`;

    return this.http.get(url, {
      params: params
    });

}

  fetchDevotee() {
    this.fetchDevoteeDetails().subscribe({
      next: (res) => {
        this.dataSubject.next(res);
      },
    });
  }

  nivedanAssign(nivedanId: string, userId: string): Observable<any> {
    const url = `${BASE_URL}${API_ENDPOINTS.NIVEDAN_ASSIGN}`;
    return this.http.post(
      url,
      {
        nivedanId,
        userId,
      },
    );
  }

 nivedanAssignTo(
  nivedanId: string,
  status?: string,
  payload?: {
    isUrgent?: boolean;
    isOnHold?: boolean;
    assignedTo?: string;
    comment?: string;
    categoryCode?: any;
    nivedanDetails?: string;
  }
): Observable<any> {
  const url = `${BASE_URL}${API_ENDPOINTS.NIVEDAN}`;

  return this.http.patch(url, {
    nivedanId,
    status,
    ...payload
  });
}

nivedanAssignToGuest(body: any): Observable<any>{
  const url = `${BASE_URL}${API_ENDPOINTS.GUEST_ASSIGN_NIVEDAN}`;

  return this.http.post(url, body)
}


  fetchCategoryList(): Observable<any> {
    const url = `${BASE_URL}${API_ENDPOINTS.CATEGORY}`;
    return this.http.get(url);
  }

  strikeComment(body: any): Observable<any> {
    return this.http.patch(`${BASE_URL}${API_ENDPOINTS.STRIKE_COMMENT}`, body)
  } 

  callRecordingSync(body: any): Observable<any> {
    return this.http.post(`${BASE_URL}${API_ENDPOINTS.RECORD_CALL_SYNC}`, body)
  }

  nivedanToDraft( devoteeDetails: any,
    addressDetails: any,
    otherDetails: any,
    nibedonDetails: any){
       let userId = localStorage.getItem('currentUserId')

    const { firstName,middleName, lastName, familyCode, phoneNumber, alternatePhoneNumber, gender, age } =
      devoteeDetails;
    const { address, pincode, district, state, po } = addressDetails;
    const { nivedanCategory, initiated, swastayini, ritwikName, martialStatus } = otherDetails;
    const { nibedon, remarks, isUrgent, call_id } = nibedonDetails;

    const url = `${BASE_URL}${API_ENDPOINTS.DRAFT_NIVEDAN}`;
    return this.http.post<any>(
      url,
      {
        devoteeDetails: {
          married: martialStatus,
          ritwikName: ritwikName,
          swastayani: swastayini,
          initiated: initiated,
          state: state,
          dist: district,
          address: address,
          pin: pincode,
          gender: gender,
          age: age,
          familyCode: familyCode,
          lastName: lastName,
          firstName: firstName,
          middleName: middleName,
          phoneNumber: phoneNumber,
          alternateMobileNumber: alternatePhoneNumber,
          postOffice: po
        },
        nivedanDetails: {
          createdByRole: 'AGENT',
          createdBy: userId,
          recordingPath: null,
          recordingStatus: null,
          remark: remarks,
          nivedanDetails: nibedon,
          isUrgent:isUrgent,
          categoryCode: nivedanCategory,
          status: 'PENDING ON ADMIN',
          agentCode: 'string',
          call_id: this.piopiy.getCallId()
        },
      },
    );
    }

  draftNivedanSubmit(nibedonId: any,
     devoteeDetails: any,
    addressDetails: any,
    otherDetails: any,
    nibedonDetails: any): Observable<any>{
      let userId = localStorage.getItem('currentUserId')

    const { firstName,middleName, lastName, familyCode, phoneNumber, alternatePhoneNumber, gender, age } =
      devoteeDetails;
    const { address, pincode, district, state, po } = addressDetails;
    const { nivedanCategory, initiated, swastayini, ritwikName, martialStatus } = otherDetails;
    const { nibedon, remarks, isUrgent, isOnHold, call_id } = nibedonDetails;
     return this.http.patch(`${BASE_URL}nivedan/${nibedonId}/submit-draft`,
       {
        devoteeDetails: {
          married: martialStatus,
          ritwikName: ritwikName,
          swastayani: swastayini,
          initiated: initiated,
          state: state,
          dist: district,
          address: address,
          pin: pincode,
          gender: gender,
          age: age,
          familyCode: familyCode,
          lastName: lastName,
          firstName: firstName,
          middleName: middleName,
          phoneNumber: phoneNumber,
          alternateMobileNumber: alternatePhoneNumber,
          postOffice: po
        },
        nivedanDetails: {
          remark: remarks,
          nivedanDetails: nibedon,
          isUrgent,
          isOnHold,
          categoryCode: nivedanCategory,
          status: 'PENDING ON ADMIN',
          agentCode: 'string',
        },
      },
     )
   
  }


}
